export const proxima_nova = `'Proxima Nova', 'Helvetica Neue', Helvetica, Arial, sans-serif`
